import { render, staticRenderFns } from "./CfsisTable.vue?vue&type=template&id=5f12b754&scoped=true&"
import script from "./CfsisTable.vue?vue&type=script&lang=js&"
export * from "./CfsisTable.vue?vue&type=script&lang=js&"
import style0 from "./CfsisTable.vue?vue&type=style&index=0&id=5f12b754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12b754",
  null
  
)

export default component.exports